import mark from '../../images/gf-mark.svg';

/**
 * The GoldFinder lockup: pin-and-pickaxe mark plus the two-tone wordmark.
 *
 * Matches the landing page. The wordmark is live text rather than part of the
 * SVG so it picks up Poppins from the app's own stylesheet - an <img>-loaded
 * SVG can't fetch a webfont, so baking the text into the file would silently
 * fall back to a system sans and drift from the landing page.
 */
export function GoldFinderLogo({ height = 40, style = {} }) {
  const markSize = Math.round(height * 0.86);
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: Math.max(6, Math.round(height * 0.18)),
        lineHeight: 1,
        ...style,
      }}
    >
      <img src={mark} alt="" width={markSize} height={markSize} style={{ display: 'block', flex: 'none' }} />
      <span
        style={{
          fontFamily: 'var(--gf-font-sans, "Poppins", sans-serif)',
          fontWeight: 700,
          fontSize: Math.round(height * 0.46),
          letterSpacing: '-0.02em',
          whiteSpace: 'nowrap',
        }}
      >
        <span style={{ color: 'var(--gf-secondary-800, #12181B)' }}>Gold</span>
        <span style={{ color: 'var(--gf-secondary-500, #57646B)', fontWeight: 600 }}>Finder</span>
      </span>
    </span>
  );
}

export default GoldFinderLogo;
